import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BuildingEvent from './components/BuildingEvent/BuildingEvent'
import AppointmentEvent from './components/AppointmentEvent/AppointmentEvent'
import ClassEvent from './components/ClassEvent/ClassEvent'
import ReminderEvent from './components/ReminderEvent/ReminderEvent'

export class EditEvent extends React.Component {
  renderEditForm() {
    const { activeTraining } = this.props.event
    if (activeTraining.event) {
      return (
        <BuildingEvent
          editMode
          handleClose={this.props.close}
          eventData={this.props.event.activeTraining}
          repeatable={!!this.props.event.activeTraining.repeatCorrelationId}
        />
      )
    }
    if (activeTraining.type.name === 'Reminder') {
      return (
        <ReminderEvent
          editMode
          eventData={this.props.event.activeTraining}
          handleClose={this.props.close}
          repeatable={!!this.props.event.activeTraining.repeatCorrelationId}
        />
      )
    }
    if (activeTraining.mainClient) {
      return (
        <AppointmentEvent
          editMode
          eventData={this.props.event.activeTraining}
          handleClose={this.props.close}
          repeatable={!!this.props.event.activeTraining.repeatCorrelationId}
        />
      )
    }
    return (
      <ClassEvent
        editMode
        eventData={this.props.event.activeTraining}
        handleClose={this.props.close}
        repeatable={!!this.props.event.activeTraining.repeatCorrelationId}
      />
    )
  }

  render() {
    return this.renderEditForm()
  }
}

EditEvent.propTypes = {
  close: PropTypes.func,
  event: PropTypes.object,
}
export default connect((state) => ({
  event: state.event,
}))(EditEvent)
